import { api } from './request'

/**
 * 入驻申请管理 API
 */

// 获取入驻申请列表
export function getApplications(params) {
  return api.get('/admin/settlement/applications', {
    params: {
      page: params.page || 1,
      per_page: params.per_page || 20,
      status: params.status || '',
      farm_name: params.farm_name || ''
    }
  })
}

// 获取入驻申请详情
export function getApplicationDetail(id) {
  return api.get(`/admin/settlement/applications/${id}`)
}

// 审核入驻申请
export function reviewApplication(id, data) {
  return api.put(`/admin/settlement/applications/${id}/review`, {
    status: data.status,
    notes: data.notes || ''
  })
}

// 获取已入驻用户列表
export function getSettledUsers(params) {
  return api.get('/admin/settlement/users', {
    params: {
      page: params.page || 1,
      per_page: params.per_page || 20,
      username: params.username || '',
      status: params.status || ''
    }
  })
}

// 切换入驻状态
export function toggleSettlementStatus(id) {
  return api.put(`/admin/settlement/users/${id}/toggle`)
}

export default {
  getApplications,
  getApplicationDetail,
  reviewApplication,
  getSettledUsers,
  toggleSettlementStatus
}